import packageJson from '../../package.json';

export const environment = {
  apiUrl: 'https://fb-ulms.aakil.net',
  metabaseApiUrl: 'https://fb-ulms.aakil.net/loan/api/metabase',
  apiDocUrl: 'https://fb-ulms.aakil.net',
  apiBioUrl: 'https://fb-ulms.aakil.net',
  mcpApiUrl: 'https://fb-ulms.aakil.net/mcp',
  mcpNotificationsEnabled: true,
  keycloakHost: 'https://fb-ukc.aakil.net',
  keycloak: {
    // Url of the Identity Provider
    issuer: 'https://fb-ukc.aakil.net/auth/realms/LMS',

    // URL of the SPA to redirect the user to after login
    redirectUri: 'https://fb-ulms.aakil.net/',

    // The SPA's id.
    // The SPA is registerd with this id at the auth-serverß
    clientId: 'web_app',
    oidc: true,
    responseType: 'code',
    // set the scope for the permissions the client should request
    // The first three are defined by OIDC.
    scope: 'openid profile email offline_access',
    // Remove the requirement of using Https to simplify the demo
    // THIS SHOULD NOT BE USED IN PRODUCTION
    // USE A CERTIFICATE FOR YOUR IDP
    // IN PRODUCTION
    requireHttps: true,
    strictDiscoveryDocumentValidation: false,
    skipIssuerCheck: true,

    // at_hash is not present in JWT token
    showDebugInformation: true,
    disableAtHashCheck: true,
  },
  enableDebug: true,
  serviceWorker: true,
  production: false,
  dummy_JSONs: false,
  showtrace: false,
  showClientNotes: false,
  enableNewLandingLayout: false,
  name: 'UAT',
  useMdb5Adapted: true, // Toggle for rollback
  version: packageJson.version,
  showTribute: true
};
